import React, { useState } from 'react';
import { Button, Input, Label } from 'reactstrap';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import AnimatedPage from "../pages/AnimatedPage";

const AdContent = () => {
  const [inputText, setInputText] = useState('');
  const [outputText, setOutputText] = useState('');

  const handleInputChange = (event) => {
    setInputText(event.target.value);
  };

  const handleEditorChange = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const text = contentState.getPlainText();
    setOutputText(text);
  };

  const handleGenerateAdContent = async () => {
    // call API to generate ad content with inputText and outputText
    try {
      const response = await fetch('https://tidy-healthy-armchair.glitch.me/adcontent', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ prompt: inputText })
      });
      const data = await response.json();
      console.log(data)
      setOutputText(data.answer);
      
    } catch (error) {
      console.log(error);
    }
  };

  const editorState = EditorState.createWithContent(ContentState.createFromText(outputText));

  return (
    <AnimatedPage>
    <div className="container mx-auto mt-10">

      <h2 className="text-center text-2xl font-bold mb-4">Generate Ad Content</h2>
      <p className="text-center mb-4">Enter advert description and desired message to get a result</p>
      <div className="flex flex-wrap justify-center">
        <div className="w-full md:w-1/2">
          <div className="mb-4">
            <Label htmlFor="input-text" className="text-gray-800 font-bold mb-2">Ad Description:</Label>
            <Input
              type="text"
              id="input-text"
              value={inputText}
              onChange={handleInputChange}
              className="border border-gray-400 p-2 w-full rounded-lg focus:outline-none focus:shadow-outline"
            />
          </div>
          <Button onClick={handleGenerateAdContent} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full mb-4">
            Generate Ad Content
          </Button>
        </div>
        <div className="w-full md:w-1/2">
          <div className="mb-4">
            <Label htmlFor="output-text" className="text-gray-800 font-bold mb-2">Generated Ad Content:</Label>
           
            <Editor
editorState={editorState}
onEditorStateChange={handleEditorChange}
wrapperClassName="border border-gray-400 p-2 w-full rounded-lg focus:outline-none focus:shadow-outline"
editorClassName="h-48"
toolbar={{
options: ['inline', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded'],
inline: {
options: ['bold', 'italic', 'underline'],
},
fontSize: {
options: [12, 14, 16, 18, 24, 30, 36],
},
fontFamily: {
options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Roboto', 'Times New Roman', 'Verdana'],
},
list: {
options: ['unordered', 'ordered'],
},
textAlign: {
options: ['left', 'center', 'right'],
},
}}
/>
</div>
</div>
</div>
</div>
</AnimatedPage>
);
};

export default AdContent;